import { GroundPlanContext, PrintContext } from 'src/contexts'
import { compose } from 'src/components/hoc'
import GroundPlan from './GroundPlan'

export default compose(
  PrintContext.withConsumer(({ isPrinting }) => ({ isPrinting })),

  // provide common plan props context
  GroundPlanContext.withProvider(
    ({ background, dndTargets, points, component, disabled, onPointAdd, onPointMove, onPointRemove, isPrinting }) => ({
      background,
      dndTargets,
      points,
      component,
      disabled,
      onPointAdd,
      onPointMove,
      onPointRemove,
      isPrinting,
    })
  )
)(GroundPlan)
